import { config, resolveAutomaticMeetingPrepEnabled } from '@littlebird/sdk';
import { reaction } from 'mobx';
import { useEffect, useState } from 'react';

import { subscriptionStore } from '@/features/subscription/subscription.store';
import { userStore } from '@/stores/user.store';

function getAutomaticMeetingPrepEnabled(): boolean {
  return resolveAutomaticMeetingPrepEnabled(
    config.meetings.automatic_meeting_prep_enabled,
    {
      isInternalUser: userStore.isInternalUser,
      currentPlan: subscriptionStore.currentPlan,
    }
  );
}

/** Effective setting: the user's synced preference, or its plan-based default. */
export function useAutomaticMeetingPrepEnabled(): boolean {
  const [enabled, setEnabled] = useState(getAutomaticMeetingPrepEnabled);

  useEffect(
    () =>
      reaction(getAutomaticMeetingPrepEnabled, setEnabled, {
        fireImmediately: true,
      }),
    []
  );

  return enabled;
}
